<template>
  <!--  只允许一个 组件 -->
  <a-layout style="padding-top: 65px;">
    <!--中间布局-->
    <a-layout>
      <!-- 查询&新增-->
      <a-layout style="margin: 10px">
        <a-form layout="inline" :model="param">
          <a-form-item>
            <a-input v-model:value="param.name" placeholder="名称" :allowClear="true">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="resetQuery" style="background: #E6A23C">
              重置
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleQuery({ page: 1, size: pagination.pageSize })">
              查询
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="add()">
              新增
            </a-button>
          </a-form-item>
        </a-form>
      </a-layout>

      <!--中间详图书列表-->
      <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
        <!--学习路径列表 -->
        <!-- :row-key="record => record.id" -->
        <a-table :columns="columns" :data-source="ebooks" :pagination="pagination" :loading="loading"
          @change="handleTableChange">
          <template #coverUrl="{ text: coverUrl }">
            <a-image v-if="coverUrl" :width="52" :preview="true" :src="coverUrl" alt="avatar" />
          </template>
          <template v-slot:category="{ record }"> <!-- { text, record } -->
            <span>{{ getCategoryName(record.category1Id) }} / {{ getCategoryName(record.category2Id) }}</span>
          </template>
          <template v-slot:status="{ record }">
            <a-tag v-if="record.status == 0" color="orange">未发布</a-tag>
            <a-tag v-else-if="record.status == 1" color="green">已发布</a-tag>
          </template>
          <template v-slot:action="{ record }"><!-- { text, record } -->
            <a-space size="small">
              <!-- 新页面打开 -->
              <!-- 代码编码 window.open(routeUrl.href, '_blank'); -->
              <router-link :to="'/step?trackId=' + record.id" slots="a" target="_blank">
                <a-button type="primary">
                  详情
                </a-button>
              </router-link>
              <router-link :to="'/admin/step?trackId=' + record.id" slots="a" target="_blank">
                <a-button type="primary">
                  步骤管理
                </a-button>
              </router-link>
              <a-button type="primary" @click="edit(record)">
                编辑
              </a-button>
              <!-- 发布or撤销 -->
              <a-popconfirm title="确认执行操作?" ok-text="是" cancel-text="否" @confirm="publish(record)">
                <a-button type="primary" :danger="record.status == 1" ghost>
                  <span v-if="record.status == 0">发布</span>
                  <span v-else-if="record.status == 1">撤销</span>
                </a-button>
              </a-popconfirm>
              <!-- 删除 -->
              <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                <a-button type="primary" danger>
                  删除
                </a-button>
              </a-popconfirm>
            </a-space>
          </template>
        </a-table>

      </a-layout-content>
    </a-layout>

    <!-- 模态弹出框-->
    <a-modal title="路径表单" v-model:open="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
      <a-form :model="track" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="封面">
          <a-input v-model:value="track.cover" :disabled="true" :allowClear="true" />
          <!-- 上传控件 -->
          <!-- ！！！注意 name中的file要和后台 @RequestBody MultipartFile file 中的file同名 ！！！ -->
          <a-upload v-model:file-list="fileList" name="file" list-type="picture-card" class="avatar-uploader"
            :show-upload-list="false" :action="SERVER + '/file/upload/avatar'" :before-upload="beforeUpload"
            :headers="uploadHeaders" @change="handleChange">
            <template v-if="imageUrl">
              <img :src="imageUrl" alt="avatar" />
            </template>
            <template v-else>
              <div>
                <loading-outlined v-if="coverLoading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传</div>
              </div>
            </template>
          </a-upload>
        </a-form-item>
        <a-form-item label="名称">
          <a-input v-model:value="track.name" :allowClear="true" />
        </a-form-item>
        <a-form-item label="分类">
          <a-cascader v-model:value="categoryIds" :field-names="{ label: 'name', value: 'id', children: 'children' }"
            :options="level1" />
        </a-form-item>
        <a-form-item label="描述">
          <a-input v-model:value="track.description" type="textarea" :allowClear="true" />
        </a-form-item>
      </a-form>
    </a-modal>


    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>


</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import store from "@/store";
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'AdminTrack',
  components: {
    TheFooter
  },
  setup() {
    const param = ref();
    param.value = {};
    const ebooks = ref();
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const loading = ref(false);

    const columns = [
      {
        title: '封面',
        dataIndex: 'coverUrl',
        // `column.slots` is deprecated. Please use `v-slot:headerCell` `v-slot:bodyCell` instead
        slots: { customRender: 'coverUrl' }
      },
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '描述',
        dataIndex: 'description'
      },
      {
        title: '分类',
        slots: { customRender: 'category' }
      },
      {
        title: '步骤数',
        dataIndex: 'stepCount',
        width: 80
      },
      {
        title: '电子书',
        dataIndex: 'ebookCount',
        width: 80
      },
      {
        title: '阅读数',
        dataIndex: 'viewCount',
        width: 80
      },
      {
        title: '点赞数',
        dataIndex: 'voteCount',
        width: 80
      },
      {
        title: '发布状态',
        dataIndex: 'status',
        slots: { customRender: 'status' }
      },
      {
        title: 'Action',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];

    /**
     * 数据查询
     **/
    const handleQuery = (params: any) => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      ebooks.value = [];
      axios.post("/track/list", {
        // 后台Get方法参数
        // params: {}

        // 后台Post方法参数
        page: params.page,
        size: params.size,
        name: param.value.name
      }).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          ebooks.value = result.data.list;

          // 重置分页按钮
          pagination.value.current = params.page;
          pagination.value.total = result.data.total;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 重置
     */
    const resetQuery = () => {
      console.log('resetQuery ... ')
      // 清空表单
      param.value.name = undefined
      // 重新查询
      handleQuery({
        page: 1,
        size: 10,
      });
    };

    /**
     * 表格点击页码时触发
     */
    const handleTableChange = (pagination: any) => {
      //{current: 2, pageSize: 2, total: 5}
      console.log("自带的分页参数：", pagination);
      // 查询数据
      handleQuery({
        page: pagination.current,
        size: pagination.pageSize
      });
    };


    // ------------------------ 表单 ------------------------
    /**
     * 数组，[100, 101]对应：前端开发 / Vue
     */
    const categoryIds = ref();
    const track = ref();
    const modalVisible = ref(false);
    const modalLoading = ref(false);
    const handleModalOk = () => {
      console.log('track', track.value)
      console.log('categoryIds', categoryIds.value)

      // 校验数据
      if (track.value.cover == undefined
        || track.value.name == undefined || track.value.name.trim() == ''
        || track.value.description == undefined || track.value.description.trim() == ''
        || categoryIds.value == undefined
      ) {
        message.warning('请补全数据')
        return
      }

      modalLoading.value = true;
      track.value.category1Id = categoryIds.value[0];
      track.value.category2Id = categoryIds.value[1];
      axios.post("/track/save", track.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑
     */
    const edit = (record: any) => {
      console.log('edit ', record)
      modalVisible.value = true;
      track.value = Tool.copy(record);
      imageUrl.value = record.coverUrl
      categoryIds.value = [track.value.category1Id, track.value.category2Id]
    };

    /**
     * 发布
     * @param record 
     */
    const publish = (record: any) => {
      console.log('publish ', record)
      modalLoading.value = true;
      axios.post("/track/publish", { id: record.id }).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('操作成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });

    };

    /**
     * 新增
     */
    const add = () => {
      modalVisible.value = true;
      track.value = {};       // 图书数据
      imageUrl.value = '';    // 图片封面图链接
      categoryIds.value = []; // 图书分类
      modalLoading.value = false;
    };

    /**
     * 删除
     * @param id
     */
    const handleDelete = (id: number) => {
      axios.delete("/track/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };


    const level1 = ref();
    let categorys: any;

    /**
     * 查询所有分类
     **/
    const handleQueryCategory = () => {
      loading.value = true;
      axios.get("/category/all").then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          categorys = result.data.list;
          console.log("原始数组：", categorys);

          level1.value = [];
          level1.value = Tool.array2Tree(categorys, 0);
          console.log("树形结构：", level1.value);

          // 查询列表
          handleQuery({
            page: 1,
            size: pagination.value.pageSize,
          });

        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 取出分类名称
     * @param cid
     */
    const getCategoryName = (cid: number) => {
      // console.log(cid)
      let result = "";
      categorys.forEach((item: any) => {
        if (item.id === cid) {
          // return item.name; // 注意，这里直接return不起作用
          result = item.name;
        }
      });
      return result;
    };

    // ------------------------ 上传 ------------------------
    const SERVER = process.env.VUE_APP_SERVER;
    const fileList = ref([]);
    const coverLoading = ref<boolean>(false);
    const imageUrl = ref<string>('');
    const uploadHeaders = ref({});

    const handleChange = (info: any) => {
      console.log('upload info', info)
      // status: 'done', // 状态有： uploading done error removed

      // 正在上传文件
      if (info.file.status === 'uploading') {
        coverLoading.value = true;
        return;
      }

      // 上传完毕
      if (info.file.status === 'done') {

        /**
         * 上传成功，服务器返回
         * {
            "code": 0,
            "message": "success",
            "data": {
                "fileName": "68a720e35de14ca8a926dbe3fcb2b344.png",
                "fileUrl": "http://localhost:8080/wiki-biz/images/68a720e35de14ca8a926dbe3fcb2b344.png"
            }
          }
         */
        let result = info.file.response
        console.log('result', result)
        coverLoading.value = false;
        if (result.code == 0 && result.message == 'success') {
          // 修改文件名
          track.value.cover = result.data.fileName
          // 修改图片链接
          imageUrl.value = result.data.fileUrl
        } else {
          message.error(result.message)
        }
      }

      // 上传出错
      if (info.file.status === 'error') {
        coverLoading.value = false;
        message.error('upload error');
      }
    };

    const beforeUpload = (file: any) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('图片必须小于2MB!');
      }
      // 修改请求头，携带token
      console.log('user => ', store.state.user)
      uploadHeaders.value = { "wiki-token": store.state.user.token }

      return isJpgOrPng && isLt2M;
    };

    onMounted(() => {

      console.log('用户 => ', store.state.user)
      console.log('令牌 => ', store.state.user.token)

      // 查询分类
      handleQueryCategory();



    });

    return {
      param,
      ebooks,
      pagination,
      columns,
      loading,
      edit,
      publish,
      handleQuery,
      resetQuery,
      handleTableChange,
      modalVisible,
      track,
      handleModalOk,
      add,
      modalLoading,
      handleDelete,

      getCategoryName,
      categoryIds,
      level1,


      fileList,
      coverLoading,
      imageUrl,
      handleChange,
      beforeUpload,
      uploadHeaders,
      SERVER
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
